<template src="./AddMetadata.html"></template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("metadata");
import Multiselect from "vue-multiselect";
import {notify, notifyApiError, notifyError, notifyWarn} from "@/utils/notification-helper";
import { MESSAGES } from "@/utils/constants";
export default {
  components: {
    Multiselect,
  },
  data: function () {
    return {
      add: this.$route.params.add,
      actorData: {},
      expand: true,
      actorTypeId: null,
      fieldName: null,
      fieldType: null,
      labelText: null,
      selectedDatasources: [],
      validations: {
        isDatasourceRequired: false,
      },
      datasourceObjects: [],
      options: [],
      tenants: null,
      // mandatoryList: [
      //   { name: "Yes", val: true },
      //   { name: "No", val: false },
      // ],
      isMandatory: false,
      maxLength: 0,
      displayOrder: 0,
      id:null
    };
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("metadata/cancel");
      this.$router.push({ name: "metadata" });
    },
    expandPanel() {
      let header = document.querySelectorAll("#panelbar .k-header");
      let element = document.querySelectorAll("#panelbar .k-content")[0];
      element.setAttribute("style", "display:block !important");
      header[0].addEventListener("click", () => {
        if (element.getAttribute("style") == "display: block;") {
          element.setAttribute("style", "display:none !important");
        }
      });
    },
    addDatasource(newTag) {
      // const tag = {
      //     name: newTag,
      //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      // }
      this.selectedDatasources.push(newTag);
    },
    clearEntries: function () {
      this.fieldName = null;
      this.labelText = null;
      this.fieldType = null;
      this.isMandatory = false;
      this.maxLength = 0;
      this.displayOrder = null;
      this.tenants = null;
      this.actorTypeId = null;
    },
    addActor: function () {
      if (
        this.fieldName &&
        this.labelText &&
        this.fieldType &&
        this.displayOrder > 0 &&
        this.actorTypeId
      ) {
        this.actorData = {
          FieldName: this.fieldName,
          LabelText: this.labelText,
          FieldType: this.fieldType ? this.fieldType.id : "",
          IsMandatory: this.isMandatory==="true"? true: false,
          MaxLength: parseInt(this.maxLength),
          DisplayOrder: parseInt(this.displayOrder),
          DataSource: this.selectedDatasources,
          TenantId: this.tenants ? this.tenants.tenantId : "",
          ActorID: this.actorTypeId ? this.actorTypeId.id : "",
        };
        if (this.add) {
          this.$store
            .dispatch("metadata/addActor", this.actorData)
            .then((data) => {
              if (data.success) {
                notify(MESSAGES.RECORD_CREATE_SUCCESS);
                this.goToListPage();
                this.clearEntries();
              } else {
                notifyWarn(data.message);
              }
            })
            .catch((err) => {
              try {
                notifyError(err.response.data.message);
              } catch (error) {
                notifyApiError({ message: "Something went wrong" });
              }
            });
        }else {
          this.$store
            .dispatch("metadata/updateActor", this.actorData)
            .then((data) => {
                if(data.status) {
                    notify(MESSAGES.CHANGES_SAVE_SUCCESS);
                    this.goToListPage();
                    this.clearEntries();
                } else {
                    notifyWarn(data.message);
                }
            })
            .catch(notifyApiError);
        }
      }
    },
    async getDataOnload() {
      if (!this.$route.params.add) {
        this.title = "Update Device";
        this.deviceEditData = this.$store.getters["metadata/getEditActor"];
        this.fieldName= this.deviceEditData.fieldName,
        this.labelText= this.deviceEditData.labelText,
        this.fieldType= this.initialData.fieldTypes.find(f => f.id === this.deviceEditData.fieldType),
        this.isMandatory= this.deviceEditData.isMandatory,
        this.maxLength= this.deviceEditData.maxLength,
        this.displayOrder= this.deviceEditData.displayOrder,
        this.selectedDatasources= this.deviceEditData.dataSource,
        this.options = this.selectedDatasources;
        this.tenants= this.initialData.tenants.find(t => t.tenantId === this.deviceEditData.tenantID),
        this.actorTypeId= this.initialData.actors.find(a => a.id === this.deviceEditData.actorID),
        this.id = this.deviceEditData.id;
      } else {
        this.options = this.selectedDatasources;
        this.title = "Add Device";
      }
    },
  },
  computed: {
    ...mapState(["initialData"]),
    getCommonActorTypes() {
      return this.initialData.actors;
    },
    getCommonFieldTypes() {
      return this.initialData.fieldTypes;
    },
    getTenants() {
      return this.initialData.tenants;
    },
  },
  mounted() {
    this.expandPanel();
    this.getDataOnload()
  },
};
</script>
<style lang="scss" scoped>
@import url("https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css");
@media only screen and (max-width: 768px) {
  .k-form,
  .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
  }
  .page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
  }
  .mobile_side_lbl {
    width: 70% !important;
  }
  .mobile_side_btn {
    display: flex;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    overflow-x: auto;
    padding: 10px 10px 10px 10px;
  }
}
.multiselect__tags {
  display: block;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 12px;
}
</style>